import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
@Component({
    selector: 'agpr-color-swatch-grid',
    templateUrl: './color-swatch-grid.component.html',
    styleUrls: ['./color-swatch-grid.component.scss'],
    standalone: false
})
export class ColorSwatchGridComponent {
    _hexValue: string = '';

    @Input() id: string = '_colorPickerPopover_swatch';

    @Input()
    set value(value: string) {
        this._hexValue = value.toUpperCase();
    }
    @Input() colors: string[] = [];
    @Input() emptyMessage: string = 'ColorPicker.noColorsToDisplay';
    @Input() showTooltip: boolean = true;
    @Input() maxColors: number = 10;
    @Input() ariaLabel: string = '';

    @Output() colorSelected = new EventEmitter<string>();

    readonly buttonTypesEnum = ButtonTypesEnum;

    selectColor(color: string): void {
       this.colorSelected.emit(color);
    }
}
